import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import Box from "@mui/material/Box";
import FormFooter from "../../components/FormFooter";
import { ROUTES } from "../../constants";
import { EVERYTHING_FORM } from "../../constants/validation";
import { useNotification } from "../../contexts";
import { getPropertyLease, updatePropertyLease } from "../../services/leases";
import { getProperty, updateProperty } from "../../services/properties";
import Layout from "../../components/Layout";
import PropertyForm from "./components/PropertyForm";
import Units from "./components/Units";
import LeaseForm from "./components/LeaseForm";

function AppProperty(props) {
  const history = useHistory();
  const id = props.match.params?.id;
  const { dispatch } = useNotification();
  const [property, setProperty] = useState();
  const [lease, setLease] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getProperty(id).then((data) => {
      setProperty(data);
    });
    getPropertyLease(id).then((data) => {
      setLease(data);
    });
  }, [id]);

  useEffect(() => {
    if (property && lease) {
      setIsLoading(false);
    }
  }, [property, lease]);

  const onSubmit = (values) => {
    updateProperty(id, values.property).then(() => {
      updatePropertyLease(id, values.lease).then(() => {
        dispatch({
          type: "add",
          notifications: [{ title: "Property updated with success" }],
        });
        history.push(ROUTES.PRIVATE_PROPERTIES);
      });
    });
  };

  return (
    <Layout isLoading={isLoading}>
      <Formik
        initialValues={{
          property,
          lease,
        }}
        validationSchema={EVERYTHING_FORM}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <Box sx={{ gridArea: "main" }}>
                <PropertyForm />
                <LeaseForm />
                <Units id={id} />
                <FormFooter />
              </Box>
            </form>
          );
        }}
      </Formik>
    </Layout>
  );
}

export default AppProperty;
